import { mapState, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapState({
            operationSetting: (state) => state.settings.operationSetting,
        }),
        ...mapGetters({
            exchangeRates: 'themes/settings/exchangeRate',
        }),
        interDepositRule() {
            return {
                amount: [
                    (v) =>
                        !!v || `${this.tl('amount')} ${this.tl('isRequired')}`,
                    (v) =>
                        v?.toString()?.replace(/,/g, '') > 0 ||
                        `${this.tl('amount')} ${this.tl('greaterThanZero')}`,
                    (v) =>
                        (v && parseFloat(v?.toString()?.replace(/,/g, ''))) >=
                            parseFloat(this.operationSetting?.deposit_min) ||
                        `${this.tl('minimumDepositIs')} ${this.formatCurrencyJS(
                            this.operationSetting.deposit_min
                        )}`,
                    (v) =>
                        (v && parseFloat(v?.toString()?.replace(/,/g, ''))) <=
                            parseFloat(this.operationSetting?.deposit_max) ||
                        `${this.tl('maximumDepositIs')} ${this.formatCurrencyJS(
                            this.operationSetting?.deposit_max
                        )}`,
                    (v) => this.decimalRule(v) || this.tl('decimalIsTwoDigit'),
                ],
                cryptoBankAmount: [(v) => !!v || this.tl('isRequired')],
                cryptoAmount: [
                    (v) => !!v || this.tl('isRequired'),
                    (v) =>
                        (v &&
                            parseFloat(this.form.amount?.replace(',', '')) >=
                                parseFloat(
                                    this.operationSetting.deposit_min
                                )) ||
                        `${this.tl('minDepositIs')} ${this.formatCurrencyJS(
                            this.operationSetting.deposit_min
                        )}`,
                    (v) =>
                        (v &&
                            parseFloat(this.form.amount?.replace(',', '')) <=
                                parseFloat(
                                    this.operationSetting.deposit_max
                                )) ||
                        `${this.tl('maxDepositIs')} ${this.formatCurrencyJS(
                            this.operationSetting.deposit_max
                        )}`,
                    (v) => this.decimalRule(v) || this.tl('decimalIsTwoDigit'),
                ],
            }
        },
        cryptoMessageError() {
            const amount = this.form?.amount?.replaceAll(',', '')
            if (!amount) return null
            if (parseFloat(amount) < parseFloat(this.bank.deposit_min)) {
                return `${this.tl('minDepositIs')} ${this.formatCurrencyJS(
                    this.bank.deposit_min
                )}`
            }
            if (parseFloat(amount) > parseFloat(this.bank.deposit_max)) {
                return `${this.tl('maxDepositIs')} ${this.formatCurrencyJS(
                    this.bank.deposit_max
                )}`
            }
            if (!this.decimalRule(amount)) {
                return this.tl('decimalIsTwoDigit')
            }
            return null
        },
    },
    methods: {
        decimalRule(v) {
            if (!v) return
            // Convert number to string
            const numStr = v?.replace(/,/g, '')?.toString()
            // Find the position of the decimal point
            const decimalIndex = numStr?.indexOf('.')

            // If there's no decimal point, return false
            if (decimalIndex === -1) {
                return true
            }
            // Check the length of the part after the decimal point
            const decimalPlaces = numStr.length - decimalIndex - 1
            // Return true if exactly one decimal place, otherwise false
            return decimalPlaces >= 1 && decimalPlaces <= 2
        },
    },
}
